'use client';
import type {
  ProductConf,
  ProductConfCols,
  ProductConfId,
  ProductDetail,
} from '@eliadmin/core/src/api/proform/proform-types';
import type { FieldProps } from '@eliadmin/core/src/components/configurator/configurator-field';
import { ConfiguratorField } from '@eliadmin/core/src/components/configurator/configurator-field';
import type {
  EnhancedProductConf,
  FieldDataItem,
} from '@eliadmin/core/src/stores/configurator-store';

export type ConfiguratorFieldFnOptions = {
  fieldProps: FieldProps<ConfiguratorField['type']>;
  productConfId: ProductConfId;
  productConf: ProductConf;
  value: string;
};

export type ConfiguratorSection = {
  getOrder: (options: { productConf: EnhancedProductConf; productDetail: ProductDetail }) => number;
  title: string;
  fields: ConfiguratorField[];
  isVisible?: (options: {
    productConf: EnhancedProductConf;
    productCols: ProductConfCols;
  }) => boolean;
};

export type ConfiguratorField = {
  filterFn?: (fieldData: FieldDataItem[], options: ConfiguratorFieldFnOptions) => FieldDataItem[];
  isVisible?: (options: ConfiguratorFieldFnOptions) => boolean;
  className?: string;
} & (
  | {
      id: string;
      type: 'switch' | 'textarea';
    }
  | {
      id: string;
      type: 'select';
      getFieldData?: (options: ConfiguratorFieldFnOptions) => FieldDataItem[];
      renderValueLabel?: (value?: FieldDataItem) => string;
      orderBy?: (a: FieldDataItem, b: FieldDataItem) => number;
    }
  | {
      id: string;
      type: 'radio';
      variant: 'orientation' | 'placing';
    }
  | {
      id: string;
      type: 'range';
      variant: 'vyska' | 'sirka' | 'mnozstvi' | 'poloha';
    }
  | {
      id: string;
      type: 'ornament' | 'ornament_reset';
    }
);

export type ConfiguratorFieldSectionProps = {
  fieldSection: ConfiguratorSection;
};

export function ConfiguratorFieldSection(props: ConfiguratorFieldSectionProps) {
  return (
    <div className="grid w-full grid-cols-1 gap-8 @lg:grid-cols-2 @3xl:grid-cols-3">
      {props.fieldSection.fields.map(field => {
        return <ConfiguratorField key={field.id} field={field} />;
      })}
    </div>
  );
}
